import 'react';
import 'prop-types';
import { css } from 'reakit/styled';
import { palette, theme } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import styled from '../styled/index.js';
import '../chunk-ad6ad343.js';
import { tint } from 'polished';
import _defaultPalette from '../default/palette.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import '../Spinner/styled.js';
import Spinner from '../Spinner/index.js';
import Input from 'reakit/Input';

var defaultPalette = _defaultPalette({});

var Icon = styled.svg.withConfig({
  displayName: "styled__Icon",
  componentId: "sc-1acvgnh-0"
})(["position:absolute;width:20px;height:20px;right:2px;z-index:1;fill:", ";transform:translateY(50%);pointer-events:none;&{", ";}"], palette('text'), theme('fannypack.Select.Icon.base'));
var LoadingSpinner = styled(Spinner).withConfig({
  displayName: "styled__LoadingSpinner",
  componentId: "sc-1acvgnh-1"
})(["position:absolute;top:10px;right:7px;z-index:1;"]);
var sizeProperties = {
  small: css(["font-size:0.8rem;& + ", "{width:15px;height:15px;}& + ", "{width:10px;height:10px;top:10px;}&{", ";}"], Icon, LoadingSpinner, theme('fannypack.Select.sizes.small')),
  default: css(["&{", ";}"], theme('fannypack.Select.sizes.default')),
  medium: css(["font-size:1.25rem;& + ", "{width:25px;height:25px;}& + ", "{width:20px;height:20px;top:15px;right:10px;}&{", ";}"], Icon, LoadingSpinner, theme('fannypack.Select.sizes.medium')),
  large: css(["font-size:1.5rem;& + ", "{width:30px;height:30px;}& + ", "{width:25px;height:25px;top:16px;right:12px;}&{", ";}"], Icon, LoadingSpinner, theme('fannypack.Select.sizes.large'))
};
var stateProperties = css(["border-color:", ";box-shadow:", " 0px 0px 0px 1px !important;"], function (props) {
  return palette("" + props.state)(props);
}, function (props) {
  return palette("" + props.state)(props);
});
var Select = styled(Input).withConfig({
  displayName: "styled__Select",
  componentId: "sc-1acvgnh-2"
})(["appearance:none;background:linear-gradient(rgb(255,255,255),rgb(249,250,251));border:1px solid #bdbdbd;border-radius:0.2em;color:", ";height:2.5em;padding:0.4em 1.6em 0.4em 0.6em;line-height:1.5;width:100%;&[disabled]{background:", ";box-shadow:unset;&{", ";}}&[disabled] + ", "{fill:", ";}&:focus{outline:unset;z-index:2;border-color:", ";box-shadow:", " 0px 0px 0px 1px !important;&{", ";}}&{", ";}&{", ";}", ";"], function (props) {
  return props.isPlaceholderSelected ? tint(0.4, palette('text', 0, defaultPalette.text)(props)) : palette('text')(props);
}, palette('white700'), theme('fannypack.Select.disabled'), Icon, palette('gray400'), palette('primary'), palette('primary'), theme('fannypack.Select.focus'), function (props) {
  return props.styledSize && sizeProperties[props.styledSize];
}, function (props) {
  return props.state && stateProperties;
}, theme('fannypack.Select.base'));

export default Select;
export { Icon, LoadingSpinner, Select, sizeProperties };
